import {applyUrlOverrides, getValue, renderOverridesIndicator} from './overrides';

// Load overrides
applyUrlOverrides();
renderOverridesIndicator();

// Obtain dynamic variables from server
export const provided = (window as any)._env_;

// Build-time variables
export const build: BuildTimeEnvironment = {
  sentryKey: getValue('REACT_APP_SENTRY_DSN', process.env.REACT_APP_SENTRY_DSN),
  gtmKey: getValue('REACT_APP_GTM_ID', process.env.REACT_APP_GTM_ID),
  version: getValue('REACT_APP_VERSION', process.env.REACT_APP_VERSION) || 'dev',
};

// Dynamic variables
export const dynamic: DynamicEnvironment = {
  apiUrl: getValue('REACT_APP_API_SERVER_ENDPOINT', provided?.REACT_APP_API_SERVER_ENDPOINT),
  basename: getValue('REACT_APP_ROOT_ROUTE', provided?.REACT_APP_ROOT_ROUTE),
  bannersRotationTime: parseInt(
    getValue('REACT_APP_BANNERS_ROTATION_TIME', provided?.REACT_APP_BANNERS_ROTATION_TIME) || 7 * 24 * 3600 * 1000,
    10
  ),
  disableTelemetry: getValue('REACT_APP_DISABLE_TELEMETRY', provided?.REACT_APP_DISABLE_TELEMETRY) === 'true',
  crdOperatorRevision: getValue('REACT_APP_CRD_OPERATOR_REVISION', provided?.REACT_APP_CRD_OPERATOR_REVISION) || 'main',
  debugTelemetry:
    getValue('REACT_APP_DEBUG_TELEMETRY', provided?.REACT_APP_DEBUG_TELEMETRY) === 'true' ||
    process.env.NODE_ENV !== 'production',
};

export interface BuildTimeEnvironment {
  sentryKey?: string;
  gtmKey?: string;
  version: string;
}

export interface DynamicEnvironment {
  apiUrl: string;
  basename: string;
  bannersRotationTime: number;
  disableTelemetry: boolean;
  crdOperatorRevision: string;
  debugTelemetry: boolean;
}

export default {
  ...dynamic,
  ...build,
};
